import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { useFilters } from '@domain-group/react-hooks'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useProviderPackage from '@hooks/useProviderPackage'
import useProviderPackages from '@hooks/useProviderPackages'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import BrandProviderListItem from './ProviderPackageListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const ProviderPackages = (props: { providerId: number }) => {
  const { providerId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { provider_id: providerId, ...pageFilters },
    performHttpRequests: !!providerId,
    requestOptions: {
      include_provider_package_provider: true,
    },
  }

  const providerPackagesPayload = useProviderPackages(options)
  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPackages,
    filteredProviderPackagesCount,
    hasFilteredProviderPackages,
    loading,
  } = providerPackagesPayload

  const { callbacks: { addProviderPackage } } = useProviderPackage({ provider_id: providerId })

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-packages' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Packages"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredProviderPackages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Packages present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Provider Package below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderPackages && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredProviderPackages.map(providerPackage => (
              <BrandProviderListItem
                key={providerPackage.id}
                providerPackage={providerPackage}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredProviderPackagesCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => addProviderPackage()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Provider Package
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default ProviderPackages
